/** The global strip (unit convention §1). `Body` renders it in its own slot. */
import React from 'react';

import {useStripModel} from './model';
import StripView from './View';

export default React.memo(function Strip() {
  return <StripView {...useStripModel()} />;
});
